import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { TableCell, TableRow } from '@/common/ui/table'
import { Row } from '@tanstack/react-table'
import { GetDynamicPageByIdDataResponse } from '@/modules/client-setting/type'
import { flexRender } from '@tanstack/react-table'

interface SortableRowProps {
	row: Row<GetDynamicPageByIdDataResponse>
}

export function SortableRow({ row }: SortableRowProps) {
	const {
		attributes,
		listeners,
		transform,
		transition,
		setNodeRef,
		isDragging,
	} = useSortable({
		id: row.original.id,
	})

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
	}

	return (
		<TableRow
			ref={setNodeRef}
			style={style}
			className={isDragging ? 'opacity-50' : ''}
			{...attributes}
			{...listeners}
		>
			{row.getVisibleCells().map((cell) => (
				<TableCell key={cell.id}>
					{flexRender(cell.column.columnDef.cell, cell.getContext())}
				</TableCell>
			))}
		</TableRow>
	)
}
